export const childRegistrationConstants = {
  firstProgressReportPeriod: 30,
};
